module.exports = __webpack_public_path__ + "static/img/class_2.52fae8b7.jpg";